
















// vendor
import { defineComponent, computed, ref, onMounted } from "@vue/composition-api";
// project
import { EditText, EditColor, Confirm, UploadFile, FindIcon, RenderRaw } from "@/components.generic/utility-modal";
import { ContextMenu, IContextMenu } from "@/components.generic/context-menu";
import { CreateStudyWizard } from "@/components.studies/create-study-wizard";
import { BrowseAssetModal  } from "@/components.assets/browse-asset-modal";
import { CreateAssetWizard } from "@/components.assets/create-asset-wizard";


import { useAppModals } from "@/hooks/useAppModals";

export default defineComponent({

	emits:[
		"ready",
	],
	components:{
		EditText,
		EditColor,
		Confirm,
		ContextMenu,
		CreateStudyWizard,
		FindIcon,
		UploadFile,
		CreateAssetWizard,
		RenderRaw,
		"find-asset":BrowseAssetModal,
	},
	setup(_, ctx){
		onMounted(() => ctx.emit("ready"));
		return {
			...useAppModals()
		};
	}
});

